import { BanIcon } from '@heroicons/react/outline';
import { useSelector } from 'react-redux';
import SubmitSuccess from '../../../components/Applications/SubmitSuccess';
import AccountNotFound from '../../../components/UI/AccountNotFound';
import { ClientAccount } from '../../../constants/DeveloperApplication';
import { useCurrentAccountData } from '../../../hooks/ReactQueryHooks/useCurrentAccountQuery';
import { developerApplicationSelector } from '../../../store';

const ApplicationSubmitSuccess = ({ message }: { message?: string }) => {
  const currentAccountInfo = useCurrentAccountData({});
  const accountSubdomain = currentAccountInfo?.data?.data?.subdomain;
  const { submitSuccess } = useSelector(
    developerApplicationSelector
  ).opportunityMain;

  if (!submitSuccess) {
    return (
      <>
        <div className='mx-auto flex flex-col bg-white px-5 py-6 rounded-md max-w-xl text-center justify-center items-center shadow-lg'>
          <div className='bg-red-50 p-4 rounded-full my-4'>
            <BanIcon className='h-10 w-10 text-tertiaryColor-normal' />
          </div>
          <h2 className='m-0'>Unauthorized</h2>
          <p className='mt-2 mb-5'>
            You are not authorized to access this page without submitting an
            application.
          </p>
        </div>
      </>
    );
  }

  if (accountSubdomain) {
    const subdomain = accountSubdomain.toUpperCase();
    switch (subdomain) {
      case ClientAccount.CHICAGOREBUILD:
        return (
          <SubmitSuccess message='Thank you for your interest in Chicago Rebuild Program.' />
        );
      case ClientAccount.LETS_BUILD_ACCELERATOR:
        return (
          <SubmitSuccess
            message="Thank you for your interest in Let's Build Accelerator. We will reach
          out within 10 business days."
          />
        );
      default:
        return (
          <SubmitSuccess
            message={message ? message : 'Thank you for your interest'}
          />
        );
    }
  }
  return <AccountNotFound />;
};

export default ApplicationSubmitSuccess;
